import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TableFooter from '@material-ui/core/TableFooter';
import TablePaginationActions from './pagenation';
import TablePagination from '@material-ui/core/TablePagination';
import Tooltip from '@material-ui/core/Tooltip';
import SurveyPopup from './popup.js';
import './table.css'

const SurveyTable = ({ data }) => {

  const MAX_STRING_SIZE = {
    "survey_name": 30,
    "survey_association": 20,
    "survey_platform": 15,
    "survey_language":15,
    "target_group": 18,
  };

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const useStyles = makeStyles({
    table: {
      minWidth: 40 + "em",
      paddingLeft: 3 + "em",
      paddingRight: 3 + "em",

    },
    tableHead: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "600",
      color: "#000000",
    },
    tableEntry: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "normal",
    },
    tableHeadProjName: {
      width: 23 + 'em'
    },
    tableHeadProjAttrs: {
      width: 12 + 'em'
    },
    tableHeadProjDDL: {
      width: 5 + 'em'
    },
    tableCell: {
      height: 3 + 'em',
    },
    projName: {
      color: "#7370BB",
      fontFamily: "Open Sans",
      fontSize: 1 + "em",
      fontStyle: "normal",
      fontWeight: "bold",
    },
    deadline: {
      color: "#7370BB",
      fontWeight: "600",
    }
  });

  const strSizeTruncater = (str, limit) => {
    if (typeof str === 'undefined') return
     return str.length <= limit ? str : str.substring(0, limit) + "...";
  };

  const classes = useStyles();

  // Mapp out each row of the table and assign it to the tableContent constant
  const tableContent = (rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  : data).map((entry) => {
      return (
          <TableRow >
              <TableCell className={classes.projName + " " + classes.tableCell} component="th" scope="rpw">
                <SurveyPopup dataObj={entry} triggerElement={() => {
                  return (
                    <Tooltip title={entry.survey_name}>
                      <p className="survey-link">{strSizeTruncater(entry.survey_name, MAX_STRING_SIZE.survey_name)}</p>
                    </Tooltip>
                  )}}/> 
              </TableCell>
              <TableCell className={classes.tableEntry} align="left">
                <Tooltip title={entry.survey_association}>
                  <span>{strSizeTruncater(entry.survey_association, MAX_STRING_SIZE.survey_association)}</span>
                </Tooltip>
              </TableCell>
              <TableCell className={classes.tableEntry} align="left">
                <Tooltip title={entry.survey_platform}>
                  <span>{strSizeTruncater(entry.survey_platform, MAX_STRING_SIZE.survey_platform)}</span>
                </Tooltip>
              </TableCell>
              <TableCell className={classes.tableEntry} align="left">
                <Tooltip title={entry.survey_language}>
                  <span>{strSizeTruncater(entry.survey_language, MAX_STRING_SIZE.survey_language)}</span>
                </Tooltip>
              </TableCell>
              <TableCell className={classes.tableEntry} align="left">
                <Tooltip title={entry.target_group}>
                  <span>{strSizeTruncater(entry.target_group, MAX_STRING_SIZE.target_group)}</span>
                </Tooltip>
              </TableCell>
              <TableCell className={classes.tableEntry + " " + classes.deadline} align="left">
                <Tooltip title={entry.deadline}>
                  <span>{entry.deadline}</span>
                </Tooltip>
              </TableCell>
          </TableRow>
      );
  })

  console.log(page, rowsPerPage, emptyRows, data.length)

    return (
        <div id="table-container">
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHead + " " + classes.tableHeadProjName} align="left">Survey name</TableCell>
                  <TableCell className={classes.tableHead + " " + classes.tableHeadProjAttrs} align="left">Survey association</TableCell>
                  <TableCell className={classes.tableHead + " " + classes.tableHeadProjAttrs} align="left">Survey platform</TableCell>
                  <TableCell className={classes.tableHead + " " + classes.tableHeadProjAttrs} align="left">Survey language</TableCell>
                  <TableCell className={classes.tableHead + " " + classes.tableHeadProjAttrs} align="left">Target group</TableCell>
                  <TableCell className={classes.tableHead + " " + classes.tableHeadProjDDL} align="left">Deadline</TableCell>
                </TableRow>
              </TableHead>
              
              {tableContent}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows}}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}

              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                    colSpan={6}
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { 'aria-label': 'rows per page' },
                      native: true,
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>
      );
}

export default SurveyTable
